// eslint-disable-next-line
export const EMAIL_PATTERN = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

export const NOISEWORDS_PATTERN = /\b(a(?:nd?|t)?|but|from|[io][fn]|[fn]?or|t(?:h(?:e|is)))\b/ig;

export const PHONE_PATTERN = /^(?=\D*(?:\d\D*){7,}$)(?:([\d\s+()-])(?!\1{6,}))+$/;



// WEBPACK FOOTER //
// ./const/Patterns.js